(function () {
    'use strict';

    angular
        .module('app')
        .directive('drvEntityPreview', drvEntityPreview);

    /**
     * @ngdoc directive
     * @name drvEntityPreview
     * 
     * @param {object} entity - Entity for which the preview will be shown.
     * @param {bool} showCondensed - Should a condensed single line only version of the preview be shown. Optional.
     *
     * @description
     * Formats preview text of an entity for display.
     */
    function drvEntityPreview() {
        return {
            templateUrl: 'app/entity/entity-preview.tmpl.html',
            scope: {
            },
            controller: drvEntityPreviewCtrl,
            controllerAs: 'drvCtrl',
            bindToController: {
                entity: '=',
                showCondensed: '<?'
            }
        };
    }

    drvEntityPreviewCtrl.$inject = ['$sce'];

    function drvEntityPreviewCtrl($sce) {
        /* jshint validthis:true */
        var drvCtrl = this;

        Object.defineProperty(drvCtrl, 'previewDescription', {
            get: function () {
                if (_.isNil(drvCtrl.entity)) return '';
                if (_.isNil(drvCtrl.entity.PreviewDescriptionText)) return '';

                return $sce.trustAsHtml(drvCtrl.entity.PreviewDescriptionText);
            }
        });

        Object.defineProperty(drvCtrl, 'isDeleted', {
            get: function () {
                return !_.isNil(drvCtrl.entity) && !_.isNil(drvCtrl.entity.DeletedDate);
            }
        });
    }
})();
